import React, { Component } from 'react'
import Draggable from 'react-draggable'

class Modal extends Component {
    componentDidUpdate(prevProps) {
        if (!this.props.draggable && prevProps.draggable) {
            const id = `modal-dialog-id-${this.props.id}`
            document.getElementById(id).style.transform = "translate(0px, 0px)";
        }
    }

    render() {
        const { id, show, children, style, width } = this.props
        if(!show) {
            return null
        }

        let st = style
        if (!style) {
            st = {}
            if (width) {
                st.width = `${this.props.width}px`
            }
        }

        return (
            <div id={ id } className='modal animated fadeIn' tabIndex="-1" role="dialog" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Draggable handle=".modal-header">
                    <div id={ `modal-dialog-id-${id}` } className="modal-dialog animated zoomIn" role="document" style={ st }>
                        <div className="modal-content">
                            { children }
                        </div>
                    </div>
                </Draggable>
            </div>
        )
    }
}

export default Modal


// WEBPACK FOOTER //
// ./src/components/Shared/Modal.jsx